import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { MenuModule } from 'primeng/menu';
import { AvatarModule } from 'primeng/avatar';
import { BadgeModule } from 'primeng/badge';
import { RippleModule } from 'primeng/ripple';
import { MenuItem } from 'primeng/api';
import { TranslocoModule } from '@jsverse/transloco';
import { AuthService } from '@app/modules/auth/services';
import { EntitlementsStore } from '@modules/entitlements/services';
import { UpgradeService } from '@app/shared/services/upgrade.service';
import { PlanBadgeComponent } from '@app/shared/components/plan-badge/plan-badge.component';

@Component({
  standalone: true,
  selector: 'app-dashboard-topbar',
  templateUrl: './dashboard-topbar.component.html',
  styleUrl: './dashboard-topbar.component.scss',
  imports: [
    CommonModule,
    FormsModule,
    ButtonModule,
    InputTextModule,
    InputGroupModule,
    InputGroupAddonModule,
    MenuModule,
    AvatarModule,
    BadgeModule,
  RippleModule,
  TranslocoModule,
  PlanBadgeComponent
  ]
})
export class DashboardTopbarComponent {
  @Input() isMobile: boolean = false;
  @Output() sidebarToggle = new EventEmitter<void>();

  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);
  private readonly entitlements = inject(EntitlementsStore);
  private readonly upgradeService = inject(UpgradeService);

  /** Current plan key (e.g. 'free' | 'pro'); null until entitlements load. */
  readonly plan = this.entitlements.plan;

  currentDate = new Date();
  searchValue = '';

  userMenuItems: MenuItem[] = [
    {
      label: 'Profil',
      icon: 'pi pi-user',
      command: () => this.navigateToProfile()
    },
    {
      label: 'Ustawienia',
      icon: 'pi pi-cog',
      command: () => this.navigateToSettings()
    },
    {
      separator: true
    },
    {
      label: 'Wyloguj',
      icon: 'pi pi-sign-out',
      command: () => this.logout()
    }
  ];

  notificationCount = 3;
  userName = 'Jan Kowalski';

  onMenuToggle(): void {
    this.sidebarToggle.emit();
  }

  onSearch(): void {
    if (this.searchValue.trim()) {
      console.log('Searching for:', this.searchValue);
      // Implement search functionality
    }
  }

  onNotificationClick(): void {
    console.log('Opening notifications');
    // Implement notification panel
  }

  onUpgrade(): void {
    this.upgradeService.goToPlans();
  }

  private navigateToProfile(): void {
    this.router.navigate(['/profile']);
  }

  private navigateToSettings(): void {
    this.router.navigate(['/settings']);
  }

  private logout(): void {
    this.authService.logout();
  }

  get formattedDate(): string {
    return this.currentDate.toLocaleDateString('pl-PL', {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  }
}
